import React from 'react';
import { t } from 'i18next';
import { Lottie } from '@sovryn/ui';
import { translations } from '../../../locales/i18n';
export const LoaderWithLogo = ({ text }) => (React.createElement("div", { className: "flex flex-col justify-center items-center flex-grow" },
    React.createElement("div", { className: "w-64" },
        React.createElement(Lottie, { animation: "loading" })),
    React.createElement("div", { className: "sv-loading-text" }, text ? text : t(translations.loader.loading))));
